
import axios from 'axios'
const API_URL = process.env.REACT_APP_THEME_API_URL
const verifyPan = `${API_URL}/verifyPanDetails`
const pan_submit = `${API_URL}/user/pan/save`
const bank_submit = `${API_URL}/user/bank/save`
const verifyBankApi = `${API_URL}/verifyBankDetails`
const verifyUpiApi = `${API_URL}/verifyUpiDetails`
const upi_submit = `${API_URL}/user/upi/save`
const dashboard_api = `${API_URL}/userbyProject`
const dashboard_card_api = `${API_URL}/userdetail`
const customer_login = `${API_URL}/customer_auth`
const update_address = `${API_URL}/update-address`
const get_user_address = `${API_URL}/get-user-address`
const GET_COM_LIST = `${API_URL}/company-list`
const LOGIN_CUSTOMER = `${API_URL}/app/login`
const SEND_OTP = `${API_URL}/app/send_otp`
const MATCH_CUSTOMER_OTP = `${API_URL}/app/match_otp`
const SUPPORT_QUERY = `${API_URL}/app/submit-query`
const CUS_LEDGER_LIST = `${API_URL}/user-ledger-list`
const USER_DASHBOARD = `${API_URL}/user-dashboard`
const REDEM_CATALOG = `${API_URL}/project-redem-catalog-new`
const ADD_USER_REDEM = `${API_URL}/place-redem-order-new`
const ADD_REDEM_BY_ID = `${API_URL}/get-redemption-by-id`
const GET_USER_REDEMPTION = `${API_URL}/get-user-redemption`
const GET_REDEMPTION_CAT = `${API_URL}/get-cat-subcat-redemption`
const GET_REDEMPTION_ADD_CART = `${API_URL}/add-cart-redemption-new`
const GET_REDEMPTION_CART = `${API_URL}/get-cart`
const UPDATE_CART_ITEM = `${API_URL}/update-cartitem-qty`
const DELETE_CART_ITEM = `${API_URL}/delete-cart-item`
const VOUCHER_DOWNLOAD = `${API_URL}/voucher-download`
const GET_PAGE = `${API_URL}/get-page`
const CUS_PURCHAE_LIST = `${API_URL}/user-purchase-list`
const USER_SCHEME = `${API_URL}/user-scheme`
const LOGIN_COM_CUSTOMER = `${API_URL}/app/clogin`
const LUCKY_DRAW = `${API_URL}/app/user-coupon`
const PROJECT_BY_REQUEST = `${API_URL}/app/project-by-token`
const SUBMIT_CONSENT = `${API_URL}/app/save_user_settings`
const GET_PAGE_BY_SULG = `${API_URL}/app/get_page_by_slug`
const CHECK_CART_PYSICAL = `${API_URL}/check-InCart-physical`
const API = axios.create();
const SUPPORT_TC_QUERY = `${API_URL}/app/submit-by-tc`
const GET_USER_TOKEN = `${API_URL}/app/get-user-token`
const GET_USER_AUTH = `${API_URL}/user-auth`
const GET_USER_DATA_TOKEN = `${API_URL}/app/get-user-by-token`
const GET_USER_DATA_UPDATED = `${API_URL}/app/update-user-by-token`
const LOGIN_OTP = `${API_URL}/login-with-otp`
//let authToken = JSON.parse(localStorage.getItem("user_action") || '{}').api_token;
let authToken = JSON.parse(localStorage.getItem("cuslogin") || '{}').api_token;
// Set up an interceptor to add the token to each request
API.interceptors.request.use(
    config => {
        if (authToken) {
            config.headers.Authorization = `Bearer ${authToken}`;
            if (process.env.REACT_APP_CLIENT) {
                config.headers['X-App-Client'] = process.env.REACT_APP_CLIENT
            }
            if (process.env.REACT_APP_CLIENT_KEY) {
                config.headers['X-App-Key'] = process.env.REACT_APP_CLIENT_KEY
            }
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
// Function to log in and get the token
export const authLogin = (data) => {
    return axios.post(customer_login, data)
        .then(response => {
            authToken = response.data.api_token; // Assuming the token is returned in the response data
            return response;
        })
        .catch(error => {
            console.error('Error:', error);
            throw error; // Propagate the error
        });
};
export const authLoginOtp = (data) => {
    return axios.post(LOGIN_OTP, data)
        .then(response => {
            authToken = response.data.api_token; // Assuming the token is returned in the response data
            return response;
        })
        .catch(error => {
            console.error('Error:', error);
            throw error; // Propagate the error
        });
};

export const veifryPan = (data) => {
    return API.post(verifyPan, data).then((d) => d.data);
};

export const panSubmit = (data) => {
    return API.post(pan_submit, data);
};

export const veifiyBank = (data) => {
    return API.post(verifyBankApi, data).then((d) => d.data);
};

export const getCustomerLedegerList = (query) => {
    return API.post(CUS_LEDGER_LIST, query).then((d) => d.data)
};
export const getCustomerPurchaseList = (query) => {
    return API.post(CUS_PURCHAE_LIST, query).then((d) => d.data)
};

export const bankSubmit = (data) => {
    return API.post(bank_submit, data);
};

export const vrefiyUpi = (data) => {
    return API.post(verifyUpiApi, data).then((d) => d.data.data);
};

export const upiSubmit = (data) => {
    return API.post(upi_submit, data);
};

export const getUserKyc = (mobile, key) => {
    return API.get(`${dashboard_api}/${key}/${mobile}`).then((d) => d.data);
};

export const getDashboardKYCCard = (user_id) => {
    return API.get(`${dashboard_card_api}/${user_id}`).then((d) => d.data.data);
};

export const updateAddress = (query) => {
    return API.post(update_address, query).then((d) => d.data);
};

export const getUserAddress = (query) => {
    return API.post(get_user_address, query).then((d) => d.data);
};
export const compantList = (query) => {
    return API.get(`${GET_COM_LIST}?${query}`).then((d) => d.data)
    // return axios.get(GET_STATE_LIST, query).then((response) => response.data)
}


export const sendOTP = (query) => {
    return API.post(SEND_OTP, query).then((d) => d.data);
}
export const loginCustomer = (query) => {
    return API.post(LOGIN_CUSTOMER, query).then((d) => d.data);
}

export const loginCompanyCustomer = (query) => {
    return API.post(LOGIN_COM_CUSTOMER, query).then((d) => d.data);
}

export const virifyOtpLogin = (query) => {
    return API.post(MATCH_CUSTOMER_OTP, query).then((d) => d.data);
}
export const virifyOtp = (query) => {
    return API.post(MATCH_CUSTOMER_OTP, query).then((d) => d);
}
export const supportQuery = (query) => {
    return API.post(SUPPORT_QUERY, query).then((d) => d.data);
}
export const TokenBaseSupportQuery = (query) => {
    return API.post(SUPPORT_TC_QUERY, query).then((d) => d.data);
}
export const getUserDashboard = (query) => {
    return API.post(USER_DASHBOARD, query).then((d) => d.data);
}
// export const getRedemCatalog = (query) => {

//     return API.get(`${REDEM_CATALOG}?page=${query?.page}&project_key=${query?.project_key}&search=${query?.searchTerm}`).then((d) => d.data?.data);
// }
export const getRedemCatalog = (query) => {

    return API.get(`${REDEM_CATALOG}?page=${query?.page}&project_key=${query?.project_key}&search=${query?.searchTerm}&minPoints=${query?.minPoints}
        &maxPoints=${query?.maxPoints}&categoryID=${query?.category}&sortOrder=${query?.sortOrder}&subCatID=${query?.cid}&sortByoffer=${query?.sortByOffer}`).then((d) => d.data?.data);
}
export const addUserRedem = (query) => {
    return API.post(ADD_USER_REDEM, query).then((d) => d.data);
}
export const getRedeemByID = (query) => {
    return API.post(ADD_REDEM_BY_ID, query).then((d) => d.data);
}

export const getUserRedemption = (query) => {
    return API.post(GET_USER_REDEMPTION, query).then((d) => d.data);
}
export const getCatSubCat = (query) => {
    return API.post(GET_REDEMPTION_CAT, query).then((d) => d.data);
}

export const addTocart = (query) => {
    return API.post(GET_REDEMPTION_ADD_CART, query).then((d) => d.data);
}
export const getCart = (query) => {
    return API.post(GET_REDEMPTION_CART, query).then((d) => d.data);
}

export const updatedCartItem = (query) => {
    return API.post(UPDATE_CART_ITEM, query).then((d) => d.data);
}
export const deleteCartItem = (query) => {
    return API.post(DELETE_CART_ITEM, query).then((d) => d.data);
}
export const voucherDownload = (query) => {
    return API.post(VOUCHER_DOWNLOAD, query).then((d) => d.data);
}
export const getPage = (query) => {
    return API.post(GET_PAGE, query).then((d) => d.data);
}
export const getPageBYSlug = (query) => {
    return API.post(GET_PAGE_BY_SULG, query).then((d) => d.data);
}
export const getUserScheme = () => {
    return API.get(USER_SCHEME).then((d) => d.data)
}
export const getUserLuckyDraw = (query) => {
    return API.get(`${LUCKY_DRAW}?${query}`).then((response) => response?.data)

}
export const projectByRequest = (query) => {
    return API.post(PROJECT_BY_REQUEST, query).then((d) => d.data);
}
export const submitConsentData = (query) => {
    return API.post(SUBMIT_CONSENT, query).then((d) => d.data);
}
export const checkCartItemIsPysical = (query) => {
    return API.post(CHECK_CART_PYSICAL, query).then((d) => d.data);
}
export const getUserToken = (query) => {
    return API.post(GET_USER_TOKEN, query).then((d) => d.data);
}

export const getUserAuth = (query) => {
    return API.post(GET_USER_AUTH, query).then((d) => d.data);
}

export const getUserDataByToken = (query) => {
    return API.post(GET_USER_DATA_TOKEN, query).then((d) => d.data);
}

export const getUserDataUpdated = (query) => {
    return API.post(GET_USER_DATA_UPDATED, query).then((d) => d.data);
}